import NeurowideDashboardModal from "../../sections/neurowide-dashboard-modal/NeurowideDashboardModal"
import NeurowideDashboardHeader from "../../sections/neurowide-dashboard-header/NeurowideDashboardHeader"
import NeurowideDashboardContent from "../../sections/neurowide-dashboard-content/NeurowideDashboardContent"
import RequireIsAdmin from "../../tools/RequireIsAdmin"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"
import useTeams from "../../swrCustomHooks/useTeams"

export default function NeurowideDashboard() {
    const {sessionContext} = useSessionContext()
    const {nwDashboardContext} = useNwDashboardContext()
    const {mutateTeams} = useTeams()
    return (
        <>
        <RequireIsAdmin role={sessionContext.role} redirect={true}>
            <div className="VIEW NEUROWIDE-DASHBOARD">
                <NeurowideDashboardModal type={"add"} mutateTeams={mutateTeams}/>
                <NeurowideDashboardHeader/>
                <span className="line"></span>
                <NeurowideDashboardContent/>
            </div>
        </RequireIsAdmin>
        </>
    )
}